import { generatePath } from "react-router-dom";
import {
  drawPath,
  drawRequestPath,
  fundLoanManagementPath,
  fundPath,
  invoicePath,
  lotAcqPurchaseAgreementPath,
  lotAcqSettlementStatementPath,
  lotPartitionDocumentsPath,
  lotPath,
  lotsPath,
  paymentPath,
  propertySaleSettlementStatementPath,
} from "./routes/routesDef";
import { getGraphQLBaseUrl } from "./context";

/** Present in place of an ID in URLs when creating items on CRUD pages */
export const addEntityParam = "add";

export function createLotsUrl() {
  return generatePath(lotsPath);
}

export function createLotDetailsUrl(lotId: string) {
  return generatePath(lotPath, { lotId });
}

export function createLotPartitionDocumentsUrl(lotId: string, lotPartitionId: string) {
  return generatePath(lotPartitionDocumentsPath, { lotId, lotPartitionId });
}

export function createFundDetailsUrl(fundId: string) {
  return generatePath(fundPath, { fundId });
}

export function createFundLoanManagementUrl(fundId: string) {
  return generatePath(fundLoanManagementPath, { fundId });
}

export function createDrawDetailsUrl(drawId: string) {
  return generatePath(drawPath, { drawId });
}

export function createDrawRequestDetailsUrl(drawRequestId: string) {
  return generatePath(drawRequestPath, { drawRequestId });
}

export function createPaymentDetailsUrl(paymentId: string) {
  return generatePath(paymentPath, { paymentId });
}

export function createInvoiceDetailsUrl(invoiceId: string) {
  return generatePath(invoicePath, { invoiceId });
}

export function createLotAcqSettlementStatementUrl(documentId: string) {
  return generatePath(lotAcqSettlementStatementPath, { documentId });
}

export function createPropertySaleSettlementStatementUrl(documentId: string) {
  return generatePath(propertySaleSettlementStatementPath, { documentId });
}

export function createLotAcqPurchaseAgreementUrl(documentId: string) {
  return generatePath(lotAcqPurchaseAgreementPath, { documentId });
}

export function createImportCsvUrl(type: string) {
  return `${getGraphQLBaseUrl()}/import/csv?type=${type}`;
}
